// Toggle the personalization-block when a wenskaart is chosen from the dropdown.
document.addEventListener('DOMContentLoaded', () => {
    const dropdown = document.getElementById('additional-products');
    const block = document.querySelector('.personalization-block');
    const textarea = document.getElementById('persoonlijke-tekst-op-kaartje');

    if (!dropdown || !block || !textarea) return;

    const toggle = () => {
        if (dropdown.value !== 'Nee') {
            block.classList.add('active');
            textarea.setAttribute('required', 'required');
        } else {
            block.classList.remove('active');
            textarea.removeAttribute('required');
        }
    };

    dropdown.addEventListener('change', toggle);
    toggle();
});
